import { useMutation } from '@tanstack/react-query';
import { getAppConfiguration } from '@utils/browserEnv';
import { Space, message } from 'antd';
import axios from 'axios';
import Link from 'next/link';
import { useAccessToken } from 'services';

const limitFavoriteBoats = 20;
const { cmsFullApiUrl } = getAppConfiguration();

export default function useAddToFavoriteBoat() {
  const { data: accessToken } = useAccessToken();

  const { isPending: isLoadingAdd, mutate: addToFavoriteFn } = useMutation({
    mutationFn: async (id: number) =>
      await axios({
        method: 'POST',
        url: `${cmsFullApiUrl}/user-favorite-boat/add-to-favorite`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: accessToken,
        },
        data: {
          boatId: id,
          limit: limitFavoriteBoats,
        },
      }),
    onSuccess: (data) => {
      if (data?.data?.message) {
        message.warning(
          <Space size="small">
            <span>You have reached the limit!</span>
            <Link href="/favourite-boats">View All</Link>
          </Space>,
        );
      } else {
        message.success('Favourited boat successfully');
      }
    },
    onError: () => {
      message.error('Favorite boat error');
    },
  });

  return {
    isLoadingAdd,
    addToFavoriteFn,
  };
}
